import { useState, useEffect } from "react";

export default function useDarkMode() {
  const DARK = "dark";
  const LIGHT = "light";
  let lsTheme = localStorage.theme;
  if (!lsTheme) {
    lsTheme = LIGHT;
  }

  const [theme, setTheme] = useState(lsTheme);
  let colorTheme = theme === DARK ? LIGHT : DARK;
  const isDarkMode = theme === DARK;

  //console.log(isDarkMode);
  //localStorage.setItem("theme", theme);

  function toggleTheme() {
    //console.log("toggle", theme);

    if (theme === DARK) {
      setTheme(LIGHT);
    } else {
      setTheme(DARK);
    }
  }

  function setThemeByValue(isDark) {
    //console.log("setThemeByValue isDark:" + isDark);
    // console.log("theme:" + theme);
    // console.log("colorTheme:" + colorTheme);

    //proved zmenu theme jen kdyz je rozdilny server od local
    if (isDark && theme === LIGHT) {
      setTheme(DARK);
    } else if (!isDark && theme === DARK) {
      setTheme(LIGHT);
    }
  }

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove(colorTheme);
    root.classList.add(theme);
    //console.log("changinng theme:" + theme, colorTheme);

    localStorage.setItem("theme", theme);
  }, [theme, colorTheme]);

  return [isDarkMode, toggleTheme, setThemeByValue];
}
